export const DEFAULT_RANGE_OPTIONS = [
  {
    value: "custom",
    text: "Custom",
  },
  {
    value: "today",
    text: "Today",
  },
  {
    value: "yesterday",
    text: "Yesterday",
  },
  {
    value: "last-week",
    text: "Last week",
  },
  {
    value: "last-month",
    text: "Last month",
  },
  {
    value: "last-7-days",
    text: "Last 7 days",
  },
  {
    value: "last-30-days",
    text: "Last 30 days",
  },
];

export default {};
